import React,{useState, useEffect, useRef} from 'react';
import { ReactComponent as Map} from '../components/map.svg';

import { useCookies } from 'react-cookie';
import { COOKIESPREFIX } from '../config';
import { useNavigate } from 'react-router-dom';
import { getUserInfo } from '../services/service';
import '../App.css'
import { useLayoutEffect } from 'react';
//screens
function App() {
  const [isLoaded, setIsLoaded] = useState(false)
  const navigate = useNavigate()
  // const [cookies, setCookie, removeCookie] = useCookies([`@${COOKIESPREFIX}_token`]);
  // const [gameData, setGameData] = useState(undefined)
  // const [qrPop,  setQrPop] = useState(false)
  // async function getUserData(){
  //   const res = await getUserInfo(cookies[`@${COOKIESPREFIX}_token`])
  //   if(res.errno) return
  //   setGameData(res.data)
  // }
  // useEffect(() => {
  //   // if(!cookies[`@${COOKIESPREFIX}_token`] || !gameData?.data.progress1) return navigate('/')
  //   // getUserData()
  // },[])
  // if(!gameData) return<></>


  const topRef= useRef(null)
  useLayoutEffect(()=>{
      setTimeout(()=>{
        if(topRef?.current)
         topRef.current.scrollIntoView();
      },500)
  },[])

  return (
    <div className="flex flex-col items-center justify-center w-[100%]">
      <div ref={topRef}/>
      <div className='relative'>
        <img onLoad={() => setIsLoaded(true)} src={'/images/jump.png'} className='w-[7%] absolute top-[31%] left-[3.6%] jumping' style={{zIndex:9}}/>
        {isLoaded && <>
          <div className='absolute top-[33%] left-[4%] w-[90%]' style={{zIndex:2}}>
            <Map />
          </div>
          <img src={'/images/infobg.jpg'} className='w-[100vw]'/>
          <div className='absolute w-[40%] h-[6%] top-[69.5%] left-[30%]' onClick={() => navigate(-1)}></div>
        </>}
      </div>
    </div>
  );
}

export default App;